// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import { css } from "styled-components";

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `,
};

wishListCardStyles.actionDeleteButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};

wishListCardStyles.actionLeaveButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
        margin-top: 10px;
    `,
};

wishListCardStyles.sharingStatus = {
    ...wishListCardStyles.sharingStatus,
    statusText: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    privateTooltip: {
        cssOverrides: {
            tooltipClickable: css`
                vertical-align: bottom;
                margin: 0px 5px;
                line-height: 21px;
                @media print {
                    display: none;
                }
            `,
        },
        iconProps: {
            src: HelpCircle,
            color: "primary",
        }
    },
};

wishListCardStyles.productImage = {
    ...wishListCardStyles.productImage,
    css: css`
        width: 75px;
        height: 75px;
        img {
            height: auto;
            object-fit: contain;
        }
    `,
};
